import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";

import { API_BASE_URI } from "../ApiCall";
import { EquipmentDemobiliationActionTypes } from "./EquipmentDemobiliation.type";

export function* fetchAllEquipmentDemobiliations(action: any): any {
  try {
    const response = yield axios.get(`${API_BASE_URI}/equipment-demobiliation?project_id=${action.payload.project_id}`);
    yield put({
      type: EquipmentDemobiliationActionTypes.FETCH_ALL_EQUIPMENT_DEMOBILIATION_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: EquipmentDemobiliationActionTypes.FETCH_ALL_EQUIPMENT_DEMOBILIATION_FAILURE,
      payload: error,
    });
  }
}

export function* fetchOneEquipmentDemobiliations(action: any): any {
  try {
    const response = yield axios.get(
      `${API_BASE_URI}/equipment-demobiliation/${action.payload}`
    );
    yield put({
      type: EquipmentDemobiliationActionTypes.FETCH_ONE_EQUIPMENT_DEMOBILIATION_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: EquipmentDemobiliationActionTypes.FETCH_ONE_EQUIPMENT_DEMOBILIATION_FAILURE,
      payload: error,
    });
  }
}

export function* watcherFetchAllEquipmentDemobiliations() {
  yield takeLatest(EquipmentDemobiliationActionTypes.FETCH_ALL_EQUIPMENT_DEMOBILIATION, fetchAllEquipmentDemobiliations);
}

export function* watcherFetchOneEquipmentDemobiliations() {
  yield takeLatest(EquipmentDemobiliationActionTypes.FETCH_ONE_EQUIPMENT_DEMOBILIATION, fetchOneEquipmentDemobiliations);
}
